export default "__VITE_ASSET__J6uyHtV6__"